import React, { useState } from "react";
import { useHistory, Route, Redirect } from "react-router-dom";
import  Index  from "../../views/accmanager/Index";
import CleanNavbar from "components/Navbars/CleanNavbar";
import UserSidebar from "components/Sidebar/UserSidebar";
import AccManagerSidebar from "components/Sidebar/AccManagerSidebar";
import imgtoData from "../../variables/imgManipulation";
import { getProfileInfo } from "../../network/ApiAxios";
import UserProfile from "views/user/userProfile";
import EditProfile from "views/examples/EditProfile";
import UserDocs from "views/user/UserDocs";
import { Row } from "reactstrap";
import CheckPermission from "variables/CheckPermission";
import Accommodation from "views/examples/admin/accommodation/Accommodation";

import ManualTimeClock from "views/examples/schedule/ManualTimeClock";
import NewPass from "components/Reusable Components/NewPass";


const AccManager = () => {
  const history = useHistory();
  const [pic, setpic] = useState();
  const [permission, setPermission] = useState(true);
  
  const permisson = CheckPermission()
      if(!permisson){
        setPermission(false)
      }
  let user;
  user = JSON.parse(localStorage.getItem("user"));

  // eslint-disable-next-line
  const getProfilePic = async () => {
    const data = await getProfileInfo(user.userID);
    if (data.data.data) {
      const dat = data.data.data;
      setpic(imgtoData(dat));
    } else {
      setpic(require("../../assets/img/theme/team-1-800x800.jpg").default);
    }
  };

  let Comp;
  let title;
  let path = history.location.pathname;
  // eslint-disable-next-line
  switch(path){
      case "/accmanager/profile":
        Comp=UserProfile;
        title='My Profile';
        break;
      case "/accmanager/user-profile":
        Comp=UserProfile;
        title='My Profile';
        break;
      case "/accmanager/index":
        Comp=Index;
        title='My Dashboard';
        break;
      case "/accmanager":
        Comp=Index;
        title='My Dashboard';
        break;
      case "/accmanager/profile/edit":
        Comp=EditProfile;
        title='Edit Profile';
        break;  
      case "/accmanager/documents":
        Comp=UserDocs;
        title='My Documents';
        break;  
      case "/accmanager/clockin":
        Comp=ManualTimeClock;
        title='Employee Clock in/Out';
        break;
      case "/accmanager/accommodation":
        Comp=Accommodation;
        break;
      case "/accmanager/newpass":
        Comp=NewPass;
        break; 
  }



  return permission ? <>
              
              <AccManagerSidebar
              pic={pic}
              logo={{
                innerLink: "/user/index",
                imgSrc: require("../../assets/img/brand/argon-react.png").default,
                imgAlt: "..."
              }}/>
              <div className="main-content">
                <CleanNavbar title={title} />
                <Row className="mb-8"></Row>
                <Route
                component={Comp}
                />
              </div>
          </>: <Redirect to='/' />;
};

export default AccManager;
